module.exports = __webpack_public_path__ + "static/media/venus.d2658149.svg";